module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-wrap"
  }, [_c('div', {
    staticClass: "form-item"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("申请BU：")]), _vm._v(" "), _c('div', {
    staticClass: "item-text"
  }, [_vm._v(_vm._s(_vm.data.bu_name))])]), _vm._v(" "), _c('div', {
    staticClass: "form-item"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("申请周期：")]), _vm._v(" "), _c('div', {
    staticClass: "item-text"
  }, [_vm._v(_vm._s(_vm._f("cycleStr")(_vm.data)))])]), _vm._v(" "), _c('div', {
    staticClass: "form-item"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("申请理由：")]), _vm._v(" "), _c('div', {
    staticClass: "item-text"
  }, [_vm._v(_vm._s(_vm.data.remark))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.data.status != 1),
      expression: "data.status!=1"
    }],
    staticClass: "form-item"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("审核说明：")]), _vm._v(" "), _c('div', {
    staticClass: "item-text"
  }, [_vm._v(_vm._s(_vm.data.result || "无"))])]), _vm._v(" "), _c('sliderHistoty', {
    attrs: {
      "data": _vm.data.req
    }
  }), _vm._v(" "), (_vm.data.status == 1 && _vm.$route.name != 'my-application') ? _c('div', {
    directives: [{
      name: "form",
      rawName: "v-form:apply-delay",
      arg: "apply-delay"
    }]
  }, [_c('div', {
    staticClass: "form-line",
    attrs: {
      "text": "审核处理"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-item"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("审核说明：")]), _vm._v(" "), _c('div', {
    staticClass: "item-wrap"
  }, [_c('textarea', {
    directives: [{
      name: "arg",
      rawName: "v-arg",
      value: ('审核说明'),
      expression: "'审核说明'"
    }, {
      name: "tar",
      rawName: "v-tar",
      value: (_vm.examine.result),
      expression: "examine.result"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.examine.result),
      expression: "examine.result"
    }],
    attrs: {
      "rule": "reason",
      "placeholder": "请输入审核说明"
    },
    domProps: {
      "value": (_vm.examine.result)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.examine, "result", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.checkPass
    }
  }, [_vm._v("通 过")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.checkNotPass
    }
  }, [_vm._v("不通过")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.data.status == 3 && _vm.$route.name == 'my-application') ? _c('div', {
    directives: [{
      name: "form",
      rawName: "v-form:delay-again",
      arg: "delay-again"
    }]
  }, [_c('div', {
    staticClass: "form-line",
    attrs: {
      "text": "申请"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-item"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("申请理由：")]), _vm._v(" "), _c('div', {
    staticClass: "item-wrap"
  }, [_c('textarea', {
    directives: [{
      name: "tar",
      rawName: "v-tar",
      value: (_vm.resub.delay_reason),
      expression: "resub.delay_reason"
    }, {
      name: "arg",
      rawName: "v-arg",
      value: (['申请理由']),
      expression: "['申请理由']"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.resub.delay_reason),
      expression: "resub.delay_reason"
    }],
    attrs: {
      "rule": "reason",
      "placeholder": "请输入申请理由"
    },
    domProps: {
      "value": (_vm.resub.delay_reason)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.resub, "delay_reason", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.subAgain
    }
  }, [_vm._v("重新提交")])], 1)]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-f050410e!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/slider/sliderDelay.vue
// module id = 794
// module chunks = 1